export default [

    // gestione categorie utente
    {
        path: '/families',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'1', title: 'headers.families-title'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/family-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'family-list',
                meta: {keepAlive: true, title: 'headers.families-title', mainMenuActive:'4', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/family-list')
                }
            },
            {
                path: ':id',
                name: 'family-detail',
                meta: {keepAlive: false, title: 'headers.family-detail', mainMenuActive:'4', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/family-detail')
                }
            },
            {
                path: 'new',
                name: 'family-new',
                meta: {keepAlive: false, title: 'headers.family-new', mainMenuActive:'4', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/family-new')
                }
            },
        ]
    },

    // gestione stati workflow
    {
        path: '/product-status',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'4', title: 'headers.product-status-title'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/product-status-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'product-status-list',
                meta: {keepAlive: true, title: 'headers.product-status-title', mainMenuActive:'4', subMenuActive:'4'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/product-status-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'product-status-edit',
                meta: {keepAlive: false, title: 'headers.product-status-edit-title', mainMenuActive:'4', subMenuActive:'4'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/product-status-edit')
                },
            }
        ]
    },

    // gestione gruppi di proprietà
    {
        path: '/hierarchical-groups',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'2', title: 'headers.hierarchical-group-title'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/hierarchical-group-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'hierarchical-group-list',
                meta: {keepAlive: true, title: 'headers.hierarchical-group-title', mainMenuActive:'4', subMenuActive:'2'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/hierarchical-group-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'hierarchical-group-edit',
                meta: {keepAlive: false, title: 'headers.hierarchical-group-edit-title', mainMenuActive:'4', subMenuActive:'2'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/hierarchical-group-edit')
                },
            }
        ]
    },

    // gestione tipi prodotto
    {
        path: '/product-types',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'3', title: 'headers.product-type-title'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/product-type-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'product-type-list',
                meta: {keepAlive: true, title: 'headers.product-type-title', mainMenuActive:'4', subMenuActive:'3'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/product-type-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'product-type-edit',
                meta: {keepAlive: false, title: 'headers.product-type-edit-title', mainMenuActive:'4', subMenuActive:'3'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/product-type-edit')
                },
            }
        ]
    },

    // gestione tipi messaggi
    // {
    //     path: '/message-types',
    //     meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'5', title: 'headers.message-type-title'},
    //     components: {
    //         default: () => import(/* webpackChunkName: "design" */ './views/message-type-main'),
    //         'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
    //     },
    //     children: [
    //         {
    //             path: '',
    //             name: 'message-type-list',
    //             meta: {keepAlive: true, title: 'headers.message-type-title', mainMenuActive:'4', subMenuActive:'5'},
    //             components: {
    //                 'detail-view': () => import(/* webpackChunkName: "design" */ './views/message-type-list')
    //             }
    //         },
    //         {
    //             path: 'edit/:id?',
    //             name: 'message-type-edit',
    //             meta: {keepAlive: false, title: 'headers.message-type-edit-title', mainMenuActive:'4', subMenuActive:'5'},
    //             components: {
    //                 'detail-view': () => import(/* webpackChunkName: "design" */ './views/message-type-edit')
    //             },
    //         }
    //     ]
    // },
    {
        path: '/news-management',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'6', title: 'headers.news-title'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/news-management-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'news-management-list',
                meta: {keepAlive: true, title: 'headers.news-title', mainMenuActive:'4', subMenuActive:'6'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/news-management-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'news-management-edit',
                meta: {keepAlive: false, title: 'headers.news-edit-title', mainMenuActive:'4', subMenuActive:'6'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/news-management-edit')
                },
            }
        ]
    },
    {
        path: '/properties',
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/property-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'1', title: 'headers.property-detail'},
        children: [
            {
                path: ':id',
                name: 'property-detail',
                meta: {keepAlive: false, title: 'headers.property-detail', mainMenuActive:'4', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/property-detail')
                }
            },
            {
                path: 'new/:id',
                name: 'property-new',
                meta: {keepAlive: false, title: 'headers.property-detail', mainMenuActive:'4', subMenuActive:'1'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/property-new')
                }
            },
        ]
    },
    // gestione simboli
    {
        path: '/symbols',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'5', title: 'headers.symbol-title'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/symbol-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'symbol-list',
                meta: {keepAlive: true, title: 'headers.symbol-title', mainMenuActive:'4', subMenuActive:'5'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/symbol-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'symbol-edit',
                meta: {keepAlive: false, title: 'headers.symbol-edit-title', mainMenuActive:'4', subMenuActive:'5'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/symbol-edit')
                },
            }
        ]
    },
    // regole di associazione
    {
        path: '/association-rules',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'5', title: 'headers.association-rule-detail'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/association-rule-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: ':id?/:familyid?',
                name: 'association-rule-detail',
                meta: {keepAlive: true, title: 'headers.association-rule-detail', mainMenuActive:'4', subMenuActive:'5'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/association-rule-detail')
                }
            },
        ]
    },

    // gestione commercial index
    {
        path: '/commercial-index',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'7', title: 'headers.commercial-index-main'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/commercial-index-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'commercial-index-list',
                meta: {keepAlive: true, title: 'headers.commercial-index-title', mainMenuActive:'4', subMenuActive:'7'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/commercial-index-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'commercial-index-edit',
                meta: {keepAlive: false, title: 'headers.commercial-index-edit-title', mainMenuActive:'4', subMenuActive:'7'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/commercial-index-edit')
                },
            }
        ]
    },

    // gestione benefit
    {
        path: '/benefits',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'4', subMenuActive:'8', title: 'headers.benefit-title'},
        components: {
            default: () => import(/* webpackChunkName: "design" */ './views/benefit-main'),
            'section-header': () => import(/* webpackChunkName: "design" */ './components/section-header')
        },
        children: [
            {
                path: '',
                name: 'benefit-list',
                meta: {keepAlive: true, title: 'headers.benefit-title', mainMenuActive:'4', subMenuActive:'8'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/benefit-list')
                }
            },
            {
                path: 'edit/:id?',
                name: 'benefit-edit',
                meta: {keepAlive: false, title: 'headers.benefit-edit-title', mainMenuActive:'4', subMenuActive:'8'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/benefit-edit')
                },
            },
            {
                path: 'new',
                name: 'benefit-new',
                meta: {keepAlive: false, title: 'headers.benefit-new', mainMenuActive:'4', subMenuActive:'8'},
                components: {
                    'detail-view': () => import(/* webpackChunkName: "design" */ './views/benefit-new')
                }
            },
        ]
    },


];
